import React from "react";
import Typography from "../../../components/Typography";
import { ProjectTabs } from "./ProjectTabs";
import { ActionButtonsSection } from "./ActionButtonsSection";
import ProjectsTableV2 from "./ProjectsTableV2";
import TagButtons from "./TagButtons";
import { RecommendationProjectTypeEnum } from "../../../types";
import { ViewType } from "../../../constants/enums";
import { useHomePageContext } from "../context/HomePageContext";
import { useProjectActions } from "../hooks/useProjectActions";
import { useProjectGrid } from "../hooks/useProjectGrid";
import { formatErrorMessage } from "../utils/projectUtils";

/**
 * ProjectContentSection component - Self-contained content display
 * Following Clean Code principle: Zero props, simplified component responsibility
 */
export const ProjectContentSection: React.FC = () => {
  const { projectData, uiState, actions, computed } = useHomePageContext();
  const { handleRecommendationTypeChange } = useProjectActions();
  const { renderProjectGrid } = useProjectGrid();

  const shouldShowTagButtons =
    uiState.selectedProject === "recommendation" && !computed.isLoadingRecommended;

  return (
    <div className="grid rounded-lg bg-white py-4 shadow-md">
      <div className="mb-8 flex justify-between px-4">
        <ProjectTabs />
        <ActionButtonsSection
          activeView={uiState.currentViewType}
          onFilterClick={actions.openFilterDrawer}
        />
      </div>

      {uiState.currentViewType === ViewType.LIST ? (
        <ProjectsTableV2 />
      ) : (
        <>
          {shouldShowTagButtons && (
            <div className="mb-4 flex items-center justify-between px-4">
              <TagButtons
                tags={[
                  RecommendationProjectTypeEnum.Mangroves,
                  RecommendationProjectTypeEnum.Forests,
                ]}
                selectedTag={uiState.selectedRecommendation}
                onTagClick={handleRecommendationTypeChange}
              />
            </div>
          )}
          <div className="flex w-full justify-between gap-4">
            <div className="xxl:grid-cols-3 grid h-fit w-full grid-cols-1 gap-4 px-4 sm:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-2 3xl:grid-cols-3">
              {renderProjectGrid()}
            </div>
          </div>
        </>
      )}

      {/* {computed.hasApiErrors && (
        <Typography variant="h6" color="black" className="mt-0 pb-4">
          {formatErrorMessage(
            projectData.recommendedProjects.error,
            projectData.carbonProjects.error,
          )}
        </Typography>
      )} */}
    </div>
  );
};
